import moment, { Moment } from 'moment-timezone';
import UserContext from 'src/services/UserContext';

export const getDateFormat = () => {
  return UserContext.getDateFormat();
};

export const convertMomentToString = (m?: Moment | null): string | null => {
  return m ? m.format(getDateFormat()) : null;
};

export const convertStringToMoment = (str?: string | null): Moment | null => {
  return str ? moment(str, getDateFormat()) : null;
};
